import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Col, Row } from "reactstrap";
import { change, formValueSelector } from "redux-form";
import Address1Input from "./Address1Input";
import Address2Input from "./Address2Input";
import CityInput from "./CityInput";
import CountryCodeInput from "./CountryCodeInput";
import PostalCodeInput from "./PostalCodeInput";
import RegionCodeInput from "./RegionCodeInput";
import type { ThunkDispatchType } from "src/app/reducers/IMainAppState";
import { ReactQueryResult } from "src/shared/components/ReactQueryResult";
import { useCountries } from "src/shared/contacts/countries/useCountries";
import { useRegions } from "src/shared/contacts/regions/useRegions";

export interface IFullAddressInputProps {
  isRequired?: boolean;
  form: string;
  address1InputID: string;
  address2InputID: string;
  cityInputID: string;
  regionCodeInputID: string;
  countryCodeInputID: string;
  postalCodeInputID: string;
  countriesDisabled?: boolean;
}

export default (props: IFullAddressInputProps) => {
  const { form, countryCodeInputID, regionCodeInputID, countriesDisabled } =
    props;

  const countryCode: string | undefined = useSelector((state) =>
    formValueSelector(form)(state, countryCodeInputID),
  );
  const regionCode = useSelector((state) =>
    formValueSelector(form)(state, regionCodeInputID),
  );

  const countriesResult = useCountries();

  const regionsResult = useRegions(countryCode ?? "", {
    enabled: Boolean(countryCode),
  });
  const { data: regions } = regionsResult;

  const dispatch = useDispatch<ThunkDispatchType>();
  useEffect(() => {
    if (
      regions &&
      !regions.some((region) => region.regionCode === regionCode)
    ) {
      dispatch(change(form, regionCodeInputID, null));
    }
  }, [dispatch, form, regionCode, regionCodeInputID, regions]);

  return (
    <>
      <ReactQueryResult {...countriesResult}>
        {(countries) => (
          <CountryCodeInput
            inputID={props.countryCodeInputID}
            countries={countries}
            disabled={countriesDisabled}
          />
        )}
      </ReactQueryResult>

      <Address1Input inputID={props.address1InputID} isRequired={false} />

      <Address2Input inputID={props.address2InputID} isRequired={false} />

      <Row>
        <Col sm={7}>
          <CityInput inputID={props.cityInputID} isRequired={false} />
        </Col>

        <Col sm={5}>
          {!countryCode ? (
            <RegionCodeInput
              inputID={props.regionCodeInputID}
              disabled
              regions={[]}
            />
          ) : (
            <ReactQueryResult {...regionsResult}>
              {(regions) => (
                <RegionCodeInput
                  inputID={props.regionCodeInputID}
                  regions={regions}
                />
              )}
            </ReactQueryResult>
          )}
        </Col>
      </Row>

      <PostalCodeInput inputID={props.postalCodeInputID} isRequired={false} />
    </>
  );
};
